module.exports = __webpack_public_path__ + "2c3eafcf6ea1d74ee5e3f2031e718780.svg";